<template lang="pug">
UiFormGroup(
  :label="label"
  :vuelidateModel="v$.modelValue"
)
  CompanyDimensionNamesSelect(
    :companyId="$route.params.id"
    :modelValue="modelValue"
    :disabled="!enabled"
    @update:modelValue="$emit('update:modelValue', $event)"
    :error="v$.modelValue.$error"
  )
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
import { defineComponent } from "vue";
import CompanyDimensionNamesSelect from "@/components/CompanyDimensionNamesSelect.vue";

export default defineComponent({
  components: {
    CompanyDimensionNamesSelect,
  },

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      default: null,
    },
    enabled: {
      type: Boolean,
    },
    label: {
      type: String,
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  validations() {
    return {
      modelValue: {
        required: requiredIf(this.enabled),
      },
    };
  },
});
</script>
